import { applyMiddleware, compose, createStore } from 'redux';
import reducer from '~reducers';

const composeEnhancers =
  process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

export default createStore(reducer, {}, composeEnhancers(applyMiddleware()));
